import { type ReactNode } from "react"

export type FunctionChildren<TValue> = ReactNode | ((value: TValue) => ReactNode)

export function functionChildren<TValue>(children: FunctionChildren<TValue>, value: TValue) {
    if (typeof children === "function") return children(value)

    return children
}
